import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";

export const BookingSubPaymentTypeDropDownCell = (props) => {
  const localizedDataClinicalReducedGap = [
    {
      text: "N/A",
      value: "",
    },
    {
      text: "Gap Over $30",
      value: "Over30C",
    },
    {
      text: "Gap Under $50",
      value: "Under50C",
    },
    {
      text: "Gap Over $50",
      value: "Over50C",
    },
  ];

  const localizedDataReducedGap = [
    {
      text: "N/A",
      value: "",
    },
    {
      text: "Gap Over $30",
      value: "Over30",
    },
    {
      text: "Gap Under $50",
      value: "Under50",
    },
    {
      text: "Gap Over $50",
      value: "Over50",
    },
  ];

  const localizedDataClinicalFullFee = [
    {
      text: "N/A",
      value: "",
    },
    {
      text: "Gap Over $50",
      value: "Over50C",
    },
  ];

  const localizedDataFullFee = [
    {
      text: "N/A",
      value: "",
    },
    {
      text: "Gap Over $50",
      value: "Over50",
    },
  ];

  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
      // console.log(e.target.value.value);
    }
  };

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];
  const providerType = props.dataItem.providerType;
  const paymentType = props.dataItem.service;
  return (
    <td>
      {dataItem.inEdit ? (
        <DropDownList
          style={{
            width: "150px",
          }}
          onChange={handleChange}
          value={
            providerType === "Clinical"
              ? paymentType === "Reduced Gap"
                ? localizedDataClinicalReducedGap.find((c) => c.value === dataValue)
                : localizedDataClinicalFullFee.find((c) => c.value === dataValue)
              : paymentType === "Reduced Gap"
                ? localizedDataReducedGap.find((c) => c.value === dataValue)
                : localizedDataFullFee.find((c) => c.value === dataValue)
          }
          data={
            providerType === "Clinical"
              ? paymentType === "Reduced Gap"
                ? localizedDataClinicalReducedGap
                : localizedDataClinicalFullFee
              : paymentType === "Reduced Gap"
                ? localizedDataReducedGap
                : localizedDataFullFee
          }
          textField="text"
        />
      ) : (
        dataValue.toString()
      )}{" "}
    </td>
  );
};
